
















import { Component, Prop, Vue } from 'vue-property-decorator'
import OzBaseDialogBox, {
  OzBaseDialogBoxButtonData,
  OzContainedButtonColorScheme,
} from 'library/v4/components/OzBaseDialogBox.vue'
import { __ } from 'bits/intl'

@Component({ components: { OzBaseDialogBox } })
export default class OzAlertDialogBox extends Vue {
  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Icon.
   */
  @Prop({ default: null }) iconSrc!: string | null

  /**
   * Icon alt text.
   */
  @Prop({ default: 'icon' }) iconAlt!: string

  /**
   * Title.
   */
  @Prop({ required: true }) title!: string

  /**
   * Body.
   */
  @Prop() body?: string

  /**
   * Shadow scheme.
   */
  @Prop({ default: false }) xShadow!: boolean

  /**
   * Close button text.
   */
  @Prop() closeButtonText?: string

  get buttons(): OzBaseDialogBoxButtonData[] {
    /**
     * Emits events passed in via the `buttons` prop.
     * @event close
     */
    const closeButton = {
      text: this.closeButtonText || __('Okay'),
      emit: 'close',
      colorScheme: OzContainedButtonColorScheme.Secondary,
    }
    return [closeButton]
  }

  close(): void {
    /**
     * Closed.
     */
    this.$emit('close')
  }
}
